const BOOKS = [
  "genesis","exodus","leviticus","numbers","deuteronomy",
  "joshua","judges","ruth",
  "1 samuel","2 samuel","1 kings","2 kings",
  "1 chronicles","2 chronicles",
  "ezra","nehemiah","esther",
  "job","psalm","psalms","proverbs","ecclesiastes","song of solomon",
  "isaiah","jeremiah","lamentations","ezekiel","daniel",
  "hosea","joel","amos","obadiah","jonah","micah",
  "nahum","habakkuk","zephaniah","haggai","zechariah","malachi",
  "matthew","mark","luke","john","acts","romans",
  "1 corinthians","2 corinthians","galatians","ephesians",
  "philippians","colossians","1 thessalonians","2 thessalonians",
  "1 timothy","2 timothy","titus","philemon",
  "hebrews","james","1 peter","2 peter",
  "1 john","2 john","3 john","jude","revelation"
];

const BOOK_ALIASES = {
  gen: "genesis",
  ex: "exodus",
  lev: "leviticus",
  num: "numbers",
  deut: "deuteronomy",
  ps: "psalm",
  psa: "psalm",
  matt: "matthew",
  mk: "mark",
  lk: "luke",
  jn: "john",
  rom: "romans",
  rev: "revelation"
};

function normalizeQuery(query = "") {
  const q = query
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/(\d)([a-z])/gi, "$1 $2")
    .trim();

  const words = q.split(" ");
  if (BOOK_ALIASES[words[0]]) {
    words[0] = BOOK_ALIASES[words[0]];
  }

  return words.join(" ");
}

/*
 * Book names are matched in lower case, but the result is read by people: it
 * titles the Scripture viewer, and labels the search suggestion. "john 3:16"
 * was tolerable as a row in a dropdown and wrong as a heading.
 *
 * Only the book is cased -- the chapter and verse are digits, and a trailing
 * range or letter ("3:16-18", "2a") is left exactly as typed.
 */
function titleCaseBook(book) {
  return book
    .split(" ")
    .map((word) =>
      /^\d/.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
}

export function detectBibleReference(query) {
  const q = normalizeQuery(query);

  for (const book of BOOKS) {
    if (q.startsWith(book)) {
      const remainder = q.slice(book.length).trim();
      const hasChapter = /^\d+/.test(remainder);

      if (hasChapter) {
        return `${titleCaseBook(book)} ${remainder}`;
      }
    }
  }

  return null;
}